export default __webpack_public_path__ + "static/img/top-space-high.206b146.jpg";